/**
 * Small utility function to wait for a given amount of time
 *
 * @param ms - milliseconds to wait
 * @returns
 */
export const wait = (ms: number): Promise<void> => new Promise(resolve => setTimeout(resolve, ms));
